import { Columns, DashboardModule } from '@domain-group/suit-theme'

import useCampaignContacts from '@hooks/useCampaignContacts'
import useSelector from '@hooks/useSelector'

import CampaignContacts from '@components/CampaignContacts'
import CampaignContributions from '@components/CampaignContributions'
import FinanceApplications from '@components/FinanceApplications'
import CampaignQuoteBuilder from '@components/QuoteBuilder/components/CampaignQuoteBuilder'
import useQuoteBuilder from '@components/QuoteBuilder/components/CampaignQuoteBuilder/hooks/useQuoteBuilder'
import ReconciliationTotals from '@components/ReconciliationTotals'

import type { CampaignModel } from '@models/types'

import Activity from '@components/EntityActivity/Activity'

import defaultRequestOptions from '@components/EntityActivity/defaultRequestOptions'

import PageLayout from '../../../../components/PageLayout'

interface PageContentProps {
  campaign: CampaignModel,
  campaignQuoteId: number,
}

const PageContent = (props: PageContentProps) => {
  const { campaign, campaignQuoteId } = props

  const quoteBuilderPayload = useQuoteBuilder({
    campaign,
    campaignQuoteId,
    generateUrlsOptions: {
      prefixRoute: `campaigns/${campaign.id}/edit`,
    },
  })

  const {
    campaignQuotePayload,
  } = quoteBuilderPayload

  const campaignContactsPayload = useCampaignContacts({
    filters: {
      campaign_id: campaign.id,
    },
    performHttpRequests: !!campaign.id,
    requestOptions: { include_campaign_contact_contact: true },
  })

  const loadingActivities = useSelector(reduxState => reduxState.activities.loading)

  return (
    <PageLayout
      activeTabBarItemKey="details"
      campaign={campaign}
      campaignQuotePayload={campaignQuotePayload}
    >
      <Columns.Main>
        <CampaignQuoteBuilder quoteBuilderPayload={quoteBuilderPayload} />

        <DashboardModule loading={loadingActivities} title="Activity">
          {!loadingActivities && (
            <Activity
              boxProps={{
                marginTop: 0, paddingBottom: 'large', paddingTop: 'medium', paddingLeft: 'large',
              }}
              disableLoading
              requestOptions={defaultRequestOptions.activity}
              subjectId={campaignQuoteId}
              subjectType="CampaignQuote"
            />
          )}
        </DashboardModule>
      </Columns.Main>

      <Columns.Sidebar>
        <ReconciliationTotals
          campaign={campaign}
          displayKeys={[
            'approved_quote_total',
            'total_combined_spend',
            'contribution_total',
          ]}
        />

        <CampaignContacts
          campaignContactsPayload={campaignContactsPayload}
          campaignId={campaign.id}
        />

        <CampaignContributions campaign={campaign} />

        <FinanceApplications campaignId={campaign.id} />
      </Columns.Sidebar>
    </PageLayout>
  )
}

export default PageContent
